/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FormDefinition,
    FormDefinitionFromJSON,
    FormDefinitionFromJSONTyped,
    FormDefinitionToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface FormDefinitionsListResponse
 */
export interface FormDefinitionsListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof FormDefinitionsListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<FormDefinition>}
     * @memberof FormDefinitionsListResponse
     */
    entries: Array<FormDefinition>;
}

export function FormDefinitionsListResponseFromJSON(json: any): FormDefinitionsListResponse {
    return FormDefinitionsListResponseFromJSONTyped(json, false);
}

export function FormDefinitionsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormDefinitionsListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(FormDefinitionFromJSON)),
    };
}

export function FormDefinitionsListResponseToJSON(value?: FormDefinitionsListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(FormDefinitionToJSON)),
    };
}


